export default {
    SET_REVA_ME: 'SET_REVA_ME',
    SET_REVA_LINEUPS: 'SET_REVA_LINEUPS',
    SET_REVA_PLAYERS: 'SET_REVA_PLAYERS',
    SET_REVA_ACCOUNTS: 'SET_REVA_ACCOUNTS',
    SET_REVA_LINEUP_FINANCIALS: 'SET_REVA_LINEUP_FINANCIALS',
    SET_REVA_PLAYER_FINANCIALS: 'SET_REVA_PLAYER_FINANCIALS',
    SET_REVA_PRICE_LIST: 'SET_REVA_PRICE_LIST',
    UPDATE_REVA_LINEUP: 'UPDATE_REVA_LINEUP',
    SET_REVA_DEBT_SUMMARY: 'SET_REVA_DEBT_SUMMARY',
    SET_REVA_LINEUP_INVOICES: 'SET_REVA_LINEUP_INVOICES',
    SET_REVA_PLAYER_INVOICES: 'SET_REVA_PLAYER_INVOICES',
    SET_REVA_SILO_BALANCES: 'SET_REVA_SILO_BALANCES',
    SET_REVA_LINEUP_SILO_BALANCES: 'SET_REVA_LINEUP_SILO_BALANCES',
    SET_REVA_INCOME_SUMMARY: 'SET_REVA_INCOME_SUMMARY',
    SET_REVA_TRANSACTIONS_SUMMARY: 'SET_REVA_TRANSACTIONS_SUMMARY',
    CLEAR_REVA_STATE: 'CLEAR_REVA_STATE',
    SET_REVA_CONNECTION_ERROR: 'SET_REVA_CONNECTION_ERROR',
};
